module.exports = __webpack_public_path__ + "static/media/inspection_icon.ac1d3abd.svg";